<div class="rs-car-data-block" (click)="raiseValueAClick($event)">
    <span class="num"
          [ngClass]="{ 'icon': iconA!=dataIcon.None, 'icon-user': iconA==dataIcon.User, 'icon-home': iconA==dataIcon.Office, 'num-zero': valueAStyle==dataValueStyle.Zero, 'num-alert': valueAStyle==dataValueStyle.Warn}">
        {{valueA}}
        <span>{{subValueA}}</span>
    </span>
    <span class="desc"
          [ngClass]="{ 'desc-alert': footerAStyle==dataValueStyle.Warn }">{{footerA}}</span>
</div>
<div class="rs-car-data-block" (click)="raiseValueBClick($event)">
    <span class="num"
          [ngClass]="{ 'icon': iconB!=dataIcon.None, 'icon-user': iconB==dataIcon.User, 'icon-home': iconB==dataIcon.Office, 'num-zero': valueBStyle==dataValueStyle.Zero, 'num-alert': valueBStyle==dataValueStyle.Warn}">
        {{valueB}}
        <span>{{subValueB}}</span>
    </span>
    <span class="desc"
          [ngClass]="{ 'desc-alert': footerBStyle==dataValueStyle.Warn }">{{footerB}}</span>
</div>